// ============================================================================
// cities.js — QYTETET, të ndara sipas shtetit dhe të ngarkuara me kërkesë.
//
// Të dhënat: GeoNames (përmes `all-the-cities`), vendbanime me popullsi ≥ 1000,
// të gjeneruara në `src/data/cities/<KOD>.json` — një skedar për shtet, i renditur
// sipas popullsisë (më i madhi i pari, sepse ai kërkohet më shpesh).
//
// PSE NDARJE SIPAS SHTETIT: gjithsej janë ~124 mijë qytete (1,5 MB). Askush s'ka
// nevojë për të gjitha — kur përdoruesi zgjedh Kosovën, shkarkohen 1 KB; kur
// zgjedh SHBA-në, 150 KB. Vite e ndan secilin në chunk të vetin automatikisht.
//
// EMRAT E KOSOVËS u korrigjuan në shqip gjatë gjenerimit (burimi i kishte në
// serbisht: "Pristina"→"Prishtinë", "Peć"→"Pejë", "Suva Reka"→"Suharekë" etj.).
//
// SHËNIM: qyteti është LISTË NDIHMËSE, jo detyrim. Fshati/vendi i saktë shkruhet
// lirisht në fushën e vet — asnjë bazë e botës nuk i ka të gjithë fshatrat.
// ============================================================================

const loaders = import.meta.glob("./data/cities/*.json");

const cache = new Map();   // kod → array emrash
const pending = new Map(); // kod → Promise

// A ka listë qytetesh për këtë shtet?
export function hasCities(code) {
  if (!code) return false;
  return !!loaders[`./data/cities/${String(code).toUpperCase()}.json`];
}

// Ngarkon (një herë) listën e qyteteve për një shtet. Kthen [] nëse s'ka.
export function loadCities(code) {
  if (!code) return Promise.resolve([]);
  const cc = String(code).toUpperCase();
  if (cache.has(cc)) return Promise.resolve(cache.get(cc));
  if (pending.has(cc)) return pending.get(cc);
  const load = loaders[`./data/cities/${cc}.json`];
  if (!load) { cache.set(cc, []); return Promise.resolve([]); }
  const p = load()
    .then((mod) => {
      const list = mod.default || mod || [];
      cache.set(cc, list);
      return list;
    })
    .catch(() => [])
    .finally(() => pending.delete(cc));
  pending.set(cc, p);
  return p;
}

// Lista e ngarkuar tashmë (pa pritur) — e dobishme gjatë renderimit.
export function citiesNow(code) {
  if (!code) return [];
  return cache.get(String(code).toUpperCase()) || [];
}
